/**
 * Ordem de CHAT para listas de mensagens (pedido do dono, 2026-09-23): mais
 * antiga em cima, mais recente embaixo, compositor abaixo da lista. O ML
 * devolve as mensagens da reclamação/mediação da mais nova para a mais
 * antiga; quem desenha impõe a ordem aqui, sem depender de quem buscou.
 *
 * `dateKey` = campo ISO da data da mensagem (`message_date` na conversa
 * pós-venda, `date_created` na reclamação). Ordenação ESTÁVEL: datas iguais
 * ou inválidas mantêm a ordem recebida. `null`/não-array volta como veio
 * (o `MediationChat` distingue "carregando" de "vazio").
 */
export function SortChronological(list, dateKey) {
    if (!Array.isArray(list)) {
        return list;
    }
    return [...list].sort((a, b) => (Date.parse(a?.[dateKey]) || 0) - (Date.parse(b?.[dateKey]) || 0));
}
